import React from 'react';
import ReactDOM from 'react-dom/client';
import LogRocket from 'logrocket';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { config } from './config';

// Initialize LogRocket only if enabled
if (config.logRocket.enabled && config.logRocket.appId !== 'YOUR_APP_ID') {
  LogRocket.init(config.logRocket.appId);
  console.log('LogRocket initialized');
} else {
  console.log('LogRocket not initialized. Set REACT_APP_LOGROCKET_APP_ID and REACT_APP_LOGROCKET_ENABLED=true to enable.')
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);